import { useQuery } from '@tanstack/react-query';
import { createContext, useContext, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { api, ApiError, type Me } from './api.ts';
import { Spinner } from '../components/ui.tsx';

const MeContext = createContext<Me | null>(null);

export function useMe(): Me {
  const me = useContext(MeContext);
  if (!me) throw new Error('useMe fora de RequireAuth');
  return me;
}

export const useIsAdmin = () => useMe().role === 'admin';

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const q = useQuery({ queryKey: ['me'], queryFn: api.me, retry: false, staleTime: 60_000 });
  if (q.isPending) return <Spinner />;
  if (q.error instanceof ApiError && q.error.status === 401) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }
  if (q.error) {
    return (
      <div className="mx-auto max-w-md p-8 text-center text-sm text-slate-600" role="alert">
        Não foi possível falar com a API do Nexus. {q.error.message}
      </div>
    );
  }
  if (q.data.kind !== 'user') return <Navigate to="/login" replace />;
  return <MeContext.Provider value={q.data}>{children}</MeContext.Provider>;
}
